/* ==========================================================================
   Product page, phones only: keep the Shopify Inbox chat launcher out of the
   way while the shopper is choosing a size (2026-09-27, Selami request).

   Problem: the floating "Χρειάζεστε βοήθεια;" pill sat on top of the size
   buttons, the ΟΔΗΓΟΣ ΜΕΓΕΘΩΝ link and the add-to-cart area.
   Behaviour: while the size picker / add-to-cart / try-on button is on
   screen, <html> gets `elliz-chat-away` and the launcher fades out
   (CSS in elliz-fixes.css). As soon as those leave the screen (the shopper
   scrolls to the description, reviews, recommendations) it fades back in.
   Desktop is untouched: the launcher does not cover anything there.
   ========================================================================== */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var mq = window.matchMedia('(max-width: 767px)');
  var SELECTORS = [
    'variant-selects[id^="variant-selects-"]',
    '#product-container',
    '.genlook-try-on-button'
  ];
  var onScreen = new Set();
  var io = null;

  function apply() {
    document.documentElement.classList.toggle('elliz-chat-away', mq.matches && onScreen.size > 0);
  }

  function observe() {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) onScreen.add(e.target);
          else onScreen.delete(e.target);
        });
        apply();
      });
    }
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.__ellizChatObserved) {
          el.__ellizChatObserved = true;
          io.observe(el);
        }
      });
    });
  }

  function init() {
    observe();
    /* The GenLook button is injected by its app block after load. */
    setTimeout(observe, 1500);
    setTimeout(observe, 4000);
    if (mq.addEventListener) mq.addEventListener('change', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
